import axios from "axios";

export default function SafetyeducationShowService(educationId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/safety/education/" + educationId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
